import { functions } from '../config/firebase';
import { httpsCallable } from 'firebase/functions';

// Test direct pour diagnostiquer le problème CORS
export const quickTest = async () => {
  console.log('🧪 === TEST RAPIDE ===');
  
  try {
    // Test Netatmo (référence qui marche)
    console.log('🟢 Test Netatmo...');
    const netatmoList = httpsCallable(functions, 'netatmoListAccounts');
    try {
      const netatmoResult = await netatmoList({});
      console.log('✅ Netatmo SUCCÈS:', netatmoResult.data);
    } catch (netatmoError) {
      console.log('❌ Netatmo ERREUR:', {
        code: netatmoError.code,
        message: netatmoError.message,
        details: netatmoError.details
      });
    }
    
    // Pause de 2 secondes
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // Test Automower (problème)
    console.log('🟡 Test Automower...');
    const automowerList = httpsCallable(functions, 'automowerListAccounts');
    
    // Test avec un nom différent pour vérifier le cache
    console.log('🔵 Test Automower avec nom différent...');
    const automowerListTest = httpsCallable(functions, 'automowerListAccountsTest');
    // Test fonction originale
    try {
      const automowerResult = await automowerList({});
      console.log('✅ Automower SUCCÈS:', automowerResult.data);
    } catch (automowerError) {
      console.log('❌ Automower ERREUR:', {
        code: automowerError.code,
        message: automowerError.message,
        details: automowerError.details,
        stack: automowerError.stack
      });
      
      // Vérifier si c'est vraiment une erreur CORS
      if (automowerError.code === 'functions/cors') {
        console.log('🔍 DIAGNOSTIC CORS:');
        console.log('- Function URL:', `https://us-central1-theapp-428906.cloudfunctions.net/automowerListAccounts`);
        console.log('- Origin:', window.location.origin);
        console.log('- User Agent:', navigator.userAgent);
      }
    }
    
    // Test fonction avec nom différent
    console.log('🔵 Test fonction alternative...');
    try {
      const automowerTestResult = await automowerListTest({});
      console.log('✅ AutomowerTest SUCCÈS:', automowerTestResult.data);
    } catch (automowerTestError) {
      console.log('❌ AutomowerTest ERREUR:', {
        code: automowerTestError.code,
        message: automowerTestError.message,
        details: automowerTestError.details
      });
    }
    
  } catch (error) {
    console.error('💥 Erreur générale:', error);
  }
};

// Export pour console
window.quickTest = quickTest;